<div class="fsa-container">
  <div class="message-card red mb-3">
    <span>{{ coverageTab.fsaMessageForDisplay }}</span>
  </div>
  <div class="content-container">
    <div class="title">
      {{ coverageTab.coverageTabName }}
    </div>
    <div class="content p-3">
      <div class="mb-2 message-card">
        {{ coverageTab.fsaLimitForDisplay }}
      </div>
      <div class="row my-3">
        <div class="col-3">
          <div class="fsa-continaer-card">
            <div class="fsa-title">
              <mwp-text-translate text="FSA Plan Year:" jsonKey="fsaPlanYear" />
            </div>
            <div class="fsa-content pb-1">
              {{ coverageTab.fsaCalendarForDisplay }}
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="fsa-continaer-card" [ngClass]="isDeductionValid ? 'green' : 'red'">
            <div class="fsa-title">
              <mwp-text-translate text="Annual Contribution:" jsonKey="fsaAnnualContribution" />
            </div>
            <div class="fsa-content">
              <mwp-input [form]="coverageFormGroup" [hideLabel]="true" [nameForControl]="fsaAnnualContribution" [maskType]="maskType.currency" />
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="fsa-continaer-card">
            <div class="fsa-title">{{ coverageTab.fsaEmpNoticeLabelForDisplay }}</div>
            <div class="fsa-content pb-1" [ngClass]="isDeductionValid ? 'green' : 'red'">{{ deductionAmount | currency }}</div>
          </div>
        </div>
        <div class="col-3">
          <div class="fsa-continaer-card">
            <div class="fsa-title">
              <mwp-text-translate text="Remaining Deductions for calendar year:" jsonKey="fsaRemainingDeductions" />
            </div>
            <div class="fsa-content pb-1" [ngClass]="isDeductionValid ? 'green' : 'red'">{{ coverageTab.fsaFrequencyForCalculation }}</div>
          </div>
        </div>
      </div>
      @if (coverageTab.fsaNoteForDisplay) {
        <div>
          {{ coverageTab.fsaNoteForDisplay }}
        </div>
      }
    </div>
  </div>
</div>